/********************************************************************
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this 
 * file in accordance with the terms of the Adobe license agreement 
 * accompanying it. 
 *******************************************************************/

export const convertKeysToCamelCase = (obj: {
  [key: string]: any;
}): { [key: string]: string | number | boolean } => {
  const camelCaseKey = (key: string): string => {
    return key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
  };

  return Object.keys(obj).reduce((result, key) => {
    const newKey = camelCaseKey(key);
    result[newKey] = obj[key];
    return result;
  }, {} as { [key: string]: any });
};
